.screen {
	min-height: 100%;
	padding: var(--space-5) var(--space-5) var(--space-7);
	max-width: var(--screen-max);
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: var(--space-5);
}

/* Header back button — square icon control sized for the header bar. */
.back {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border: none;
	background: none;
	border-radius: var(--radius-sm);
	color: var(--ink-muted);
	cursor: pointer;
}
.back:hover {
	color: var(--ink);
	background: var(--surface-input);
}

.form {
	display: flex;
	flex-direction: column;
	gap: var(--space-5);
}

.photo {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
	align-items: flex-start;
}
.photoImg {
	width: 100%;
	height: 200px;
	object-fit: cover;
	border-radius: var(--radius-md);
	background: var(--surface-input);
}
.photoEmpty {
	width: 100%;
	height: 200px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: var(--radius-md);
	border: 1px dashed color-mix(in srgb, var(--ink) 18%, transparent);
	background: var(--surface-input);
	color: var(--ink-muted);
}
.photoActions {
	display: flex;
	gap: var(--space-2);
}
.file {
	display: none;
}
.photoBtn {
	display: inline-flex;
	align-items: center;
	gap: var(--space-1);
	padding: var(--space-2) var(--space-3);
	border: 1px solid color-mix(in srgb, var(--ink) 18%, transparent);
	border-radius: var(--radius-md);
	background: var(--surface-card);
	color: var(--ink);
	font: inherit;
	font-size: 0.9rem;
	cursor: pointer;
}
.photoBtn:hover {
	background: var(--surface-input);
}
.photoRemove {
	color: var(--accent-rose);
}

/* Not <Field>: these two head a whole SectionListEditor rather than labelling
   one control, so wrapping them in a <label> would point it at whichever
   input happened to come first. Same caption treatment, different job. */
.field {
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}
.label {
	font-size: 0.75rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.error {
	margin: 0;
	color: var(--accent-rose);
	font-size: 0.9rem;
}

.actions {
	display: flex;
	justify-content: flex-end;
	gap: var(--space-2);
}
.cancel {
	padding: var(--space-2) var(--space-4);
	background: transparent;
	border: 1px solid color-mix(in srgb, var(--ink) 18%, transparent);
	border-radius: var(--radius-md);
	color: var(--ink);
	font: inherit;
	cursor: pointer;
}
.submit {
	padding: var(--space-2) var(--space-4);
	background: var(--accent-sage);
	border: none;
	border-radius: var(--radius-md);
	color: #fff;
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}
.submit:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
